<template>
  <div class="l-video">
    <iframe ref="video" 
      @load="loadVideo"
      :src="videoParseUrl" 
      frameborder="0" 
      width="100%" height="100%" 
      webkitallowfullscreen 
      mozallowfullscreen 
      allowfullscreen 
      fullscreen 
      allow="autoplay"
      style="background-color: #000000" />
  </div>
</template>

<script>
  import moment from 'moment/src/moment';
  import { mapGetters } from 'vuex';
  import { find, head } from 'lodash';
  import { parse } from 'himalaya';
  import Player from '@vimeo/player';

  export default {
    name: 'l-video',

    props: {
      videoId: {
        type: Number,
      },
      videoUrl: {
        type: String,
      },
      nextVideoId: {
        type: Number,
      },
      isCourseCard: {
        type: Boolean,
        default: false,
      },
      courseId: {
        type: Number,
      },
      isVideoAutoState: {
        type: Boolean,
        default: true,
      },
      savedPreviewVideoLecture: {
        type: Object,
      },
    },

    data() {
      return {
        player: null,
        pauseVideoTime: 20,
      };
    },

    computed: {
      ...mapGetters({
        isSubscriptionUser: 'isSubscriptionUser',
      }),

      videoParse() {
        return head(parse(this.videoUrl)).attributes;
      },

      videoParseUrl() {
        return `${find(this.videoParse, { key: 'src' }).value}&autoplay=1`;
      },

      isNextVideoId() {
        return this.nextVideoId !== 0;
      },

      playedDate() {
        return this.savedPreviewVideoLecture && this.savedPreviewVideoLecture.date;
      },

      isPlayedPreviewVideo() {
        return !this.isSubscriptionUser
          && this.playedDate === moment().format('YYYY-MM-DD')
          && Number(this.savedPreviewVideoLecture.viedo_lecture_id) !== this.videoId;
      },

    },

    methods: {
      loadVideo() {
        this.player = new Player(this.$refs.video);

        if (this.isPlayedPreviewVideo) {
          return this.unloadVideo();
        }

        if (
          this.isNextVideoId
          && this.isVideoAutoState
          && this.isSubscriptionUser
        ) {
          return this.player.on('timeupdate', (data) => {
            if (data.percent === 1) {
              if (this.isCourseCard) {
                return this.$router.push(`/video/${this.nextVideoId}?course_id=${this.courseId}`);
              }

              return this.$router.push(`/video/${this.nextVideoId}`);
            }
            return true;
          });
        }

        return true;
      },

      unloadVideo() {
        return this.player.on('timeupdate', (data) => {
          if (data.seconds > this.pauseVideoTime) {
            this.$ga.event({
              eventCategory: 'recommended_lectures',
              eventLabel: 'video',
              eventAction: 'preview',
            });
            this.player.unload()
              .then(() => (
                this.player.pause()
                  .then(() => (this.$emit('openPrimeModal')))
              ));
          }
        });
      },

    },

    watch: {
      isVideoAutoState(isAutoState) {
        if (isAutoState) {
          return this.loadVideo();
        }

        if (!isAutoState) {
          this.player = new Player(this.$refs.video);
          if (this.isPlayedPreviewVideo) {
            return this.unloadVideo();
          }

          if (this.isSubscriptionUser) {
            return this.player.off('timeupdate');
          }
        }

        return true;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .l-video {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;

    iframe {
      height:100%;
      width:100%;
      top:0;
      left:0;
      right:0;
      bottom:0;
      position:absolute;
    }
  }

</style>


// WEBPACK FOOTER //
// Lvideo.vue?013608e8